
import apiService from "../../errorHandling/appService";

const ESXP_ASK_ENDPOINT_PATTERN = /^\/?api\/ragquery\/ask(?:card)?(?:[/?#]|$)/i;
let esxpModeEnabled = false;

export const setEsxpModeEnabled = (enabled: boolean): void => {
  esxpModeEnabled = enabled;
};

export const applyEsxpModeContext = (
  url: string,
  postData: object | FormData
): object | FormData => {
  if (
    !ESXP_ASK_ENDPOINT_PATTERN.test(url)
    || postData instanceof FormData
  ) {
    return postData;
  }

  if (!esxpModeEnabled) {
    return {
      ...postData,
      appName: 'mcapshelpplatform',
    };
  }

  return {
    ...postData,
    appName: 'esxpplatform',
    hostPlatform: 'esxp',
    userRole: 'Non Services User',
  };
};

export const getExternalConsumptionAPI = async (
    url: string,
    parentContext: any
  ): Promise<any> => {
    try {
      const auth = parentContext.authContext;
      const accounts = auth.getAllAccounts();
      const resource: any = { scopes: [process.env.REACT_APP_EXT_API_RESOURCE],};
      const apiEndPoint = `${process.env.REACT_APP_EXT_API_BASE_URL}`;
     const apiURL= apiEndPoint+url;
      if (accounts.length > 0) {
        auth.setActiveAccount(accounts[0]);
      }
      const token = await auth?.acquireTokenSilent(resource);
      const request = {
        headers: {
          Authorization: "Bearer " + token.accessToken,
        },
      };
       // Use the generic apiService for the request
       const response = await apiService(apiURL,'GET',null,request.headers)
      return response;
    } catch (err) {
      return err?.response || err;
    }
  };

  export const postExternalConsumptionAPI = async (
    url: string,
    postData: object | FormData,
    parentContext: any
  ): Promise<any> => {
    try {
      const auth = parentContext.authContext;
      const accounts = auth.getAllAccounts();
      const resource: any = { scopes: [process.env.REACT_APP_EXT_API_RESOURCE] };
      const apiEndPoint = `${process.env.REACT_APP_EXT_API_BASE_URL}`;
      const apiURL = apiEndPoint + url;
      postData = applyEsxpModeContext(url, postData);

      if (accounts.length > 0) {
        auth.setActiveAccount(accounts[0]);
        if (postData instanceof FormData) {
          postData.set('UserId', accounts[0].username);
        } else {
          (postData as Record<string, unknown>)['UserId'] = accounts[0].username;
        }
      }
      const token = await auth?.acquireTokenSilent(resource);
  
      let headers = {
        Authorization: "Bearer " + token.accessToken,
      };
  
      let request: any = {
        headers: headers,
        method: 'POST',
      };
  
      if (postData instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data';
        request.body = postData;
      } else {
        headers['Content-Type'] = 'application/json';
        request.body = JSON.stringify(postData);
      }
  
      let response = await apiService(apiURL, request.method, request.body, request.headers);
      return response;
    } catch (err) {   
      
      return err?.response || err;
    }
  };
  
